import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserAuthenticated } from '../model/user-authenticated.model';
import { Credentials } from '../model/user-password.model';
import { User } from '../model/user.model';
import { ChangePasswordRequest } from '../model/change-password-request.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private baseUrl = environment.urlAPI + '/auth';

  public userAuthenticated: UserAuthenticated;
  public user: User;

  constructor(private http: HttpClient) { }

  public login(entity: Credentials): Observable<UserAuthenticated> {
    const params = new URLSearchParams();
    params.append('username', entity.username!);
    params.append('password', entity.password!);
    params.append('grant_type', 'password');
    params.append('client_id', environment.clientId);
    params.append('scope', 'ui');

    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic ' + btoa(environment.clientId + ':' + environment.clientSecret)
    };

    return this.http.post<UserAuthenticated>(`${this.baseUrl}/oauth/token`, params, { headers: headers });
  }

  public self(): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}/user/self`);
  }

  public findAllRoles(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/roles`);
  }

  public changePassword(entity: ChangePasswordRequest): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/password/change`, entity);
  }

  public isLoggedIn(): boolean {
    if (this.user?.uuid) return true;

    return localStorage.getItem('HW_USER_TOKEN') ? true : false;
  }

}
